import React from 'react';

const NotificationPreference = ({ value = ['off'], onChange }) => {
  console.log('WebNotificationPreference - Render:', { receivedValue: value });
  
  const options = [
    { value: 'off', label: 'No notifications' },
    { value: '1', label: '1 day before' },
    { value: '3', label: '3 days before' },
    { value: '7', label: '7 days before' }
  ];

  const isSelected = (optionValue) => {
    // Handle empty array case
    if (value.length === 0) {
      return optionValue === 'off';
    }
    if (optionValue === 'off') {
      return value.includes('off');
    }
    return value.includes(optionValue);
  };

  const handlePress = (optionValue) => {
    let newValue;
    
    // Handle empty array case
    if (value.length === 0) {
      value = ['off'];
    }
    
    if (optionValue === 'off') {
      newValue = ['off'];
    } else {
      if (value.includes('off')) {
        // If 'off' was selected, remove it when selecting other options
        value = [];
      }
      
      if (value.includes(optionValue)) {
        // If already selected, remove it
        newValue = value.filter(v => v !== optionValue);
        // If no options left, default to 'off'
        if (newValue.length === 0) newValue = ['off'];
      } else {
        // Add new selection
        newValue = [...value, optionValue].filter(v => v !== 'off');
      }
    }
    
    console.log('Updating selections:', newValue);
    onChange(newValue);
  };

  return (
    <div className="options-container" style={styles.optionsContainer}>
      {options.map((option) => {
        const selected = isSelected(option.value);
        
        return (
          <button
            key={option.value}
            className={`option-button ${selected ? 'selected' : ''}`}
            style={{
              ...styles.optionButton,
              ...(selected ? styles.selectedOption : {})
            }}
            onClick={() => handlePress(option.value)}
            type="button"
          >
            <span
              style={{
                ...styles.optionText,
                ...(selected ? styles.selectedOptionText : {})
              }}
            >
              {option.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

const styles = {
  optionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px',
  },
  optionButton: {
    padding: '6px 12px',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    backgroundColor: '#ffffff',
    marginBottom: '8px',
    marginRight: '8px',
    cursor: 'pointer',
  },
  selectedOption: {
    backgroundColor: '#4CAF50', // Green color for selected state
    borderColor: '#4CAF50',
  },
  optionText: {
    fontSize: '14px',
    color: '#333333',
  },
  selectedOptionText: {
    color: '#FFFFFF', // White text for selected state
  }
};

export default NotificationPreference;